import { createContext, useContext, useState } from "react";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [pageName, setPageName] = useState("");
const user = JSON.parse(localStorage.getItem("userData"));

 const [profilePhoto, setProfilePhoto] = useState(
    () => user?.profile_photo || null
  );


  return (
    <PageContext.Provider value={{ pageName, setPageName, profilePhoto,
        setProfilePhoto }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePage = () => useContext(PageContext);
